import axios from "axios";
import { config } from "../../Network_Calls/config";

const getOrganizationUser = async () => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_SERVER_URL + "/customer/imp",
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

const getImplCustomers = async (impl) => {
  const response = await axios.post(
    process.env.REACT_APP_SERVER_URL + "/customer/all",
    {
      impl_name: impl,
    },
    {
      ...config(),
    }
  );
  return response;
};

const getCustomer = async (impl_id, id) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "/customer/info/" + id,
      {
        implementation_id: impl_id,
      },
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const postTag = async (impl_id, tag) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "/customer/tags/",
      {
        impl_id,
        tag,
      },
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
    return error.message;
  }
};


const getImplTags = async (impl_id) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "/customer/alltags/",
      {
        impl_id,
      },
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
    return error.message;
  }
};

const postTagData = async (tagData, tag_id) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "/customer/tag/data/",
      {
        tagData,
        tag_id,
      },
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};
const getTagData = async (tag_id) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "/customer/tagData/edit/",
      {
        tag_id,
      },
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

const deleteTag = async (tag_id) => {
  try {
    const response = await axios.delete(
      process.env.REACT_APP_SERVER_URL + `/customer/tagData/${tag_id}`,
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

const editTagData=async (cusId,tag_id) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + `/customer/tagData/editData/`,
      {
        cusId,
        tag_id
      },
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

const getViewsCount = async (domain_name, firstContactFilter, journeyType) => {
  try {
    console.log("impleeee", domain_name);
    //const impl_id = implementations.map(impl =>parseInt( impl._id));
    
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + `/customer/all-recent-cutomers`,
      {
        domain_name:domain_name,
        firstContactFilter: firstContactFilter,
        journeyType: journeyType
      },
      {
        ...config(),
      }
    );
    console.log("response", response);
    return response;
  } catch (error) {
    console.log(error);
  }
};

const getKnownSince = async (domain_name, journeyType, range) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "/customer/knownSince",
      {
        domain_name,
        journeyType,
        range,
      },
      {
        ...config(),
      }
    );

    return response;
  } catch (error) {
    console.log(error);
  }
};

const getContactsWithoutDossier = async (domain_name, journeyType) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_SERVER_URL + "/customer/contactsWithoutDossier",
      {
        domain_name,
        journeyType,
      },
      {
        ...config(),
      }
    );

    return response;
  } catch (error) {
    console.log(error);
  }
};

const saveInteraction = async (payload) => {

  const response = await axios.post(

    process.env.REACT_APP_SERVER_URL +
      "/interactions/saveInteraction",

    payload,

    {
      ...config(),
    }
  );

  return response;
};

const getStages = async (
  impl_id
) => {

  const response = await axios.post(

    process.env.REACT_APP_SERVER_URL + `/customer/stages`,

    {
      impl_id: impl_id,
    },

    {
      ...config(),
    }
  );

  return response.data;
};

const getStatus = async (
  impl_id
) => {

  const response = await axios.post(

    process.env.REACT_APP_SERVER_URL + `/customer/int-status`,

    {
      impl_id,
    },

    {
      ...config(),
    }
  );

  return response.data;
};

const createContact = async (
  payload
) => {

  const response = await axios.post(

    process.env.REACT_APP_SERVER_URL +
    `/interactions/createContact`,

    payload,

    {
      ...config(),
    }
  );

  return response;
};

const searchDropdownData = async (
  payload
) => {

  const response = await axios.post(

    process.env.REACT_APP_SERVER_URL +
    `/interactions/searchDropdownData`,

    payload,

    {
      ...config(),
    }
  );

  return response;
};

const searchMentionUsers = async (
  keyword
) => {

  const response = await axios.post(

    process.env.REACT_APP_SERVER_URL +
    `/interactions/userSearch`,

    {
      keyword,
    },

    {
      ...config(),
    }
  );

  return response;
};

const getExploreTags = async (
  domain_name,
  journeyType
) => {

  const response = await axios.post(

    process.env.REACT_APP_SERVER_URL +
      "/customer/exploreTags",

    {
      domain_name,
      journeyType,
    },

    {
      ...config(),
    }
  );

  return response;
};

const getExploreTagContacts = async (
  domain_name,
  journeyType,
  tagId
) => {

  const response = await axios.post(

    process.env.REACT_APP_SERVER_URL +
      "/customer/exploreTagContacts",

    {
      domain_name,
      journeyType,
      tagId,
    },

    {
      ...config(),
    }
  );

  return response;
};

const getCustomersWithActionPlan = async (
  domain_name,
  journeyType
) => {

  const response = await axios.post(
    process.env.REACT_APP_SERVER_URL +
      "/customer/customersWithActionPlan",

    {
      domain_name,
      journeyType,
    },

    {
      ...config(),
    }
  );

  return response;
};


const getCustomersWithoutActionPlan = async (
  domain_name,
  journeyType
) => {

  const response = await axios.post(
    process.env.REACT_APP_SERVER_URL +
      "/customer/customersWithoutActionPlan",

    {
      domain_name,
      journeyType,
    },

    {
      ...config(),
    }
  );

  return response;
};

export {
  getViewsCount,
  getOrganizationUser,
  getImplCustomers,
  getCustomer,
  postTag,
  getImplTags,
  postTagData,
  getTagData,
  deleteTag,
  editTagData,
  getKnownSince,
  getContactsWithoutDossier,
  saveInteraction,
  getStages,
  getStatus,
  createContact,
  searchDropdownData,
  searchMentionUsers,
  getExploreTags,
  getExploreTagContacts,
  getCustomersWithActionPlan,
  getCustomersWithoutActionPlan,
};
